<template>
  <Dialogo
    ref="dialogo"
    @closed="$emit('cancelado')"
    :disabled="loading || submitting"
    :title="title"
    :subtitle="subtitle"
    v-bind="$attrs"
  >
    <v-form @submit.prevent="handleSubmit">
      <v-card-text>
        <v-alert
          v-if="errorMessage"
          type="error"
          v-text="errorMessage"
        ></v-alert>
        <slot :form="form" :errors="errors"></slot>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click="cancel" text>{{ cancelText }}</v-btn>
        <v-btn type="submit" :loading="submitting" color="primary">{{
          submitText
        }}</v-btn>
      </v-card-actions>
    </v-form>
  </Dialogo>
</template>

<script>
import Dialogo from "./Dialogo.vue";

export default {
  props: {
    title: String,
    subtitle: String,
    cancelText: {
      type: String,
      default: "Cancelar"
    },
    submitText: {
      type: String,
      default: "Confirmar"
    },
    handler: Function
  },

  components: {
    Dialogo
  },

  data: () => ({
    loading: false,
    submitting: false,
    form: {},
    errors: {},
    errorMessage: ""
  }),

  methods: {
    open(initialForm = {}) {
      this.form = { ...initialForm };
      this.errors = {};
      this.errorMessage = "";
      this.$refs.dialogo.open();
    },

    cancel() {
      this.$refs.dialogo.close();
      this.$emit("cancelado");
    },

    async handleSubmit() {
      this.errors = {};
      this.errorMessage = "";
      this.submitting = true;
      try {
        await this.handler(this.form);
        this.$emit("enviado");

        this.$refs.dialogo.close();
      } catch (error) {
        console.error(error);

        if (!error.response) {
          this.errorMessage = "Erro inesperado, tente novamente mais tarde";
          return;
        }

        if (error.response.status === 422) {
          this.errorMessage = "Corrija o formulário e tente novamente";
          this.errors = error.response.data.errors;
          return;
        }

        if (error.response.status === 400) {
          this.errorMessage = error.response.data.message;
          return;
        }

        this.errorMessage = "Erro inesperado, tente novamente mais tarde";
      } finally {
        this.submitting = false;
      }
    }
  }
};
</script>
